import { Attributes } from 'react';
import { HeaderEditorDesktop } from './header-editor-desktop/HeaderEditorDesktop';
import { HeaderEditorMobile } from './header-editor-mobile/HeaderEditorMobile';
import { withWebResponsiveDesign } from 'src/hoc/withWebResponsiveDesign';
import { observer } from 'mobx-react-lite';
import { StyleSheet, View } from 'react-native';
import { useStore } from 'src/contexts/StoreContext';
import { ON_SAVE_WAITING_TIME } from '../../../settings-layer/edit-settings-layer/EditSettingsLayer.constants';
import { TestIDs } from 'src/constants/testIDs.constants';

type THeaderEditorProps = Attributes & { onBack: () => Promise<void>; onSave: () => Promise<void> };
const HeaderEditorComponent = withWebResponsiveDesign<THeaderEditorProps>(HeaderEditorMobile, HeaderEditorDesktop);

export const HeaderEditor = observer(() => {
  const {
    dynamicModal: { closeModal },
    project: { activePreview, goBack },
  } = useStore();

  return (
    activePreview && (
      <View testID={TestIDs.HEADER_EDITOR_CONTAINER} style={styles.container}>
        <HeaderEditorComponent
          onSave={() => {
            activePreview.saveAll();
            setTimeout(() => {
              // close Save Changes Modal
              closeModal();
              activePreview.refreshAll();
              goBack();
            }, ON_SAVE_WAITING_TIME);
            return Promise.resolve();
          }}
          onBack={() => {
            activePreview.cancelAll();
            activePreview.refreshAll();
            return Promise.resolve();
          }}
        />
      </View>
    )
  );
});

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
});
